// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__3K2-o","track":"Slider_track__1kCQ4","dualSlider":"Slider_dualSlider__15zSG","dualTrack":"Slider_dualTrack__yDDcF","thumb":"Slider_thumb__n_GTp"};